module.exports = __webpack_public_path__ + "img/img44.8a44e598.svg";